import * as React from 'react';
import './CustomModifiedMarker.less';

const CustomModifiedMarker: React.FC = () => <span className="custom-modified-marker">M</span>;

export default CustomModifiedMarker;
